import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import api from '../api';

const card = {
  background: '#120c09', border: '1px solid rgba(237,228,211,0.08)',
  borderRadius: 16, padding: 24, marginBottom: 24,
  boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
  backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
};
const inputStyle = {
  display: 'block', width: '100%', background: 'transparent',
  border: '1px solid rgba(237,228,211,0.08)', borderRadius: 12,
  padding: '10px 16px', color: '#ede4d3', fontSize: 16,
  fontFamily: '"Geist", "Inter", system-ui, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: 12,
};

export default function Settings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '' });
  const [pwMsg, setPwMsg] = useState('');
  const [pwErr, setPwErr] = useState('');
  const [pwLoading, setPwLoading] = useState(false);
  const [deletePassword, setDeletePassword] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const [delErr, setDelErr] = useState('');

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPwErr(''); setPwMsg(''); setPwLoading(true);
    try {
      await api.post('/auth/change-password', pwForm);
      setPwMsg('Password changed successfully.');
      setPwForm({ currentPassword: '', newPassword: '' });
    } catch (err) { setPwErr(err.response?.data?.error || 'Failed to change password'); }
    setPwLoading(false);
  };

  const handleExport = async () => {
    try {
      const { data } = await api.get('/auth/export');
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = 'ghostlight-data-export.json'; a.click();
      URL.revokeObjectURL(url);
    } catch { alert('Failed to export data'); }
  };

  const handleDelete = async () => {
    if (!deletePassword) { setDelErr('Password required'); return; }
    setDelErr(''); setDelLoading(true);
    try {
      await api.delete('/auth/account', { data: { password: deletePassword } });
      logout(); navigate('/login');
    } catch (err) { setDelErr(err.response?.data?.error || 'Failed to delete account'); }
    setDelLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', paddingBottom: 120, background: '#0e0a08' }}>
      <Navbar />

      <div style={{ borderBottom: '1px solid rgba(237,228,211,0.08)' }}>
        <div style={{ maxWidth: 680, margin: '0 auto', padding: '20px 22px' }}>
          <h2 style={{ fontFamily: '"Instrument Serif", serif', fontSize: 24, color: '#ede4d3', margin: 0 }}>Settings</h2>
        </div>
      </div>

      <main style={{ maxWidth: 680, margin: '0 auto', padding: '24px 22px' }}>
        {/* Account info */}
        <div style={card}>
          <h3 style={{ fontFamily: '"Instrument Serif", serif', fontSize: 16, color: '#ede4d3', fontWeight: 600, margin: '0 0 12px' }}>Your Account</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 0' }}>
            <span style={{ fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 15, color: 'rgba(237, 228, 211, 0.38)' }}>Alias</span>
            <span style={{ fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 15, color: '#e8b547' }}>{user.alias}</span>
            <span style={{ fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 15, color: 'rgba(237, 228, 211, 0.38)' }}>Department</span>
            <span style={{ fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 15, color: '#ede4d3', textTransform: 'capitalize' }}>{user.department}</span>
            <span style={{ fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 15, color: 'rgba(237, 228, 211, 0.38)' }}>Role</span>
            <span style={{ fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 15, color: '#ede4d3', textTransform: 'capitalize' }}>{user.role}</span>
          </div>
        </div>

        {/* Change password */}
        <div style={card}>
          <h3 style={{ fontFamily: '"Instrument Serif", serif', fontSize: 16, color: '#ede4d3', fontWeight: 600, margin: '0 0 12px' }}>Change Password</h3>
          {pwMsg && <p style={{ color: '#8bc38a', fontSize: 15, fontFamily: '"Geist", "Inter", system-ui, sans-serif', marginBottom: 12 }}>{pwMsg}</p>}
          {pwErr && <p style={{ color: '#d47e6a', fontSize: 15, fontFamily: '"Geist", "Inter", system-ui, sans-serif', marginBottom: 12 }}>{pwErr}</p>}
          <form onSubmit={handleChangePassword}>
            <input type="password" required value={pwForm.currentPassword}
              onChange={e => setPwForm(f => ({ ...f, currentPassword: e.target.value }))}
              placeholder="Current password" style={inputStyle}
              onFocus={e => e.target.style.borderColor = 'rgba(232,181,71,0.4)'} onBlur={e => e.target.style.borderColor = 'rgba(237,228,211,0.08)'} />
            <input type="password" required minLength={8} value={pwForm.newPassword}
              onChange={e => setPwForm(f => ({ ...f, newPassword: e.target.value }))}
              placeholder="New password (8+ characters)" style={inputStyle}
              onFocus={e => e.target.style.borderColor = 'rgba(232,181,71,0.4)'} onBlur={e => e.target.style.borderColor = 'rgba(237,228,211,0.08)'} />
            <button type="submit" disabled={pwLoading} style={{
              background: '#b88f38', color: '#fff', fontFamily: '"Geist", "Inter", system-ui, sans-serif',
              fontWeight: 600, fontSize: 14, padding: '8px 20px', borderRadius: 10,
              border: 'none', cursor: 'pointer', opacity: pwLoading ? 0.5 : 1,
            }}>{pwLoading ? '...' : 'Change Password'}</button>
          </form>
        </div>

        {/* Data export */}
        <div style={card}>
          <h3 style={{ fontFamily: '"Instrument Serif", serif', fontSize: 16, color: '#ede4d3', fontWeight: 600, margin: '0 0 12px' }}>Export Your Data</h3>
          <p style={{ color: 'rgba(237, 228, 211, 0.38)', fontSize: 14, fontFamily: '"Geist", "Inter", system-ui, sans-serif', marginBottom: 12 }}>Download all your data as JSON: account info, posts, debriefs, check-ins.</p>
          <button onClick={handleExport} style={{
            background: 'rgba(237,228,211,0.04)', border: '1px solid rgba(237,228,211,0.08)',
            color: '#ede4d3', fontFamily: '"Geist", "Inter", system-ui, sans-serif', fontSize: 14,
            padding: '8px 20px', borderRadius: 12, cursor: 'pointer',
          }}>Download Data Export</button>
        </div>

        {/* Legal */}
        <div style={card}>
          <h3 style={{ fontFamily: '"Instrument Serif", serif', fontSize: 16, color: '#ede4d3', fontWeight: 600, margin: '0 0 12px' }}>Legal</h3>
          <div style={{ display: 'flex', gap: 16 }}>
            <Link to="/terms" style={{ color: '#e8b547', fontSize: 15, fontFamily: '"Geist", "Inter", system-ui, sans-serif', textDecoration: 'none' }}>Terms of Service</Link>
            <Link to="/privacy" style={{ color: '#e8b547', fontSize: 15, fontFamily: '"Geist", "Inter", system-ui, sans-serif', textDecoration: 'none' }}>Privacy Policy</Link>
          </div>
        </div>

        {/* Delete account */}
        <div style={{ ...card, border: '1px solid rgba(212,126,106,0.3)' }}>
          <h3 style={{ fontFamily: '"Instrument Serif", serif', fontSize: 16, color: '#d47e6a', fontWeight: 600, margin: '0 0 8px' }}>Delete Account</h3>
          <p style={{ color: 'rgba(237, 228, 211, 0.38)', fontSize: 14, fontFamily: '"Geist", "Inter", system-ui, sans-serif', marginBottom: 12 }}>
            This permanently deletes your account, alias, posts, debriefs, and check-ins. This cannot be undone.
          </p>
          {!deleteConfirm ? (
            <button onClick={() => setDeleteConfirm(true)} style={{
              color: '#d47e6a', fontSize: 14, fontFamily: '"Geist", "Inter", system-ui, sans-serif',
              background: 'transparent', border: '1px solid rgba(212,126,106,0.3)',
              padding: '8px 16px', borderRadius: 12, cursor: 'pointer',
            }}>I want to delete my account</button>
          ) : (
            <div>
              {delErr && <p style={{ color: '#d47e6a', fontSize: 15, fontFamily: '"Geist", "Inter", system-ui, sans-serif', marginBottom: 12 }}>{delErr}</p>}
              <input type="password" value={deletePassword}
                onChange={e => setDeletePassword(e.target.value)}
                placeholder="Enter your password to confirm" style={inputStyle}
                onFocus={e => e.target.style.borderColor = 'rgba(232,181,71,0.4)'} onBlur={e => e.target.style.borderColor = 'rgba(237,228,211,0.08)'} />
              <div style={{ display: 'flex', gap: 12 }}>
                <button onClick={() => { setDeleteConfirm(false); setDeletePassword(''); setDelErr(''); }}
                  style={{ color: 'rgba(237, 228, 211, 0.38)', fontSize: 14, fontFamily: '"Geist", "Inter", system-ui, sans-serif', background: 'transparent', border: 'none', cursor: 'pointer' }}>Cancel</button>
                <button onClick={handleDelete} disabled={delLoading}
                  style={{
                    background: 'rgba(212,126,106,0.12)', color: '#d47e6a', fontSize: 14,
                    fontFamily: '"Geist", "Inter", system-ui, sans-serif', padding: '8px 20px', borderRadius: 12,
                    border: '1px solid rgba(212,126,106,0.3)', cursor: 'pointer',
                    opacity: delLoading ? 0.5 : 1,
                  }}>{delLoading ? '...' : 'Permanently Delete'}</button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
